import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import { CanDeactivateGuard, getCustomFlattenedPermissionName, NavigationGuard, NavigationGuardData, NavigationPermission } from '@skykick/core';
import { GeneralNotificationsAdminCenterComponent } from './general-notifications-admin-center/general-notifications-admin-center.component';
import { NotificationsAdminCenterComponent } from './notifications-admin-center.component';
import { ProductNotificationsAdminCenterComponent } from './product-notifications-admin-center/product-notifications-admin-center.component';
import { ProductNavigationGuard } from './guards/product-navigation.guard';
import { CustomPermissions } from 'src/app/utilities/custom-permissions.util';

export const NOTIFICATIONS_ADMIN_CENTER_ROUTES_PERMISSIONS = [
  getCustomFlattenedPermissionName(
    CustomPermissions.notifications,
    NavigationPermission.Read
  )
];

export const NOTIFICATIONS_ADMIN_CENTER_ROUTES: Routes = [
  {
    path: 'notifications',
    redirectTo: 'notifications/general',
    pathMatch: 'prefix',
  },
  {
    path: 'notifications',
    component: NotificationsAdminCenterComponent,
    canActivateChild: [NavigationGuard],
    children: [
      {
        path: 'general',
        canDeactivate: [CanDeactivateGuard],
        component: GeneralNotificationsAdminCenterComponent,
        data: {
          navigationGuardData: {
            mandatoryPermissions: NOTIFICATIONS_ADMIN_CENTER_ROUTES_PERMISSIONS,
            permissionAbsentRedirect: 'settings',
          } as NavigationGuardData,
        },
      },
      {
        path: 'products/:product',
        canDeactivate: [CanDeactivateGuard],
        component: ProductNotificationsAdminCenterComponent,
        canActivate: [ProductNavigationGuard],
        data: {
          navigationGuardData: {
            mandatoryPermissions: NOTIFICATIONS_ADMIN_CENTER_ROUTES_PERMISSIONS,
            permissionAbsentRedirect: 'settings',
          } as NavigationGuardData,
        },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(NOTIFICATIONS_ADMIN_CENTER_ROUTES)],
  exports: [RouterModule],
})
export class NotificationsRoutingModule {}
